export function addCurrent(quickresponse) {
    return {
        type: 'ADD_CURRENT',
        quickresponse,
    }
}
